const ProcurementLocationType = {
  CHECK_SELECTED_LOCATION_VALUE_UPDATE: 'CHECK_SELECTED_LOCATION_VALUE_UPDATE',
  CLEAR_PROCUREMENT_LOCATION_CREATION: 'CLEAR_PROCUREMENT_LOCATION_CREATION',

  CREATE_UPDATE_PROCUREMENT_LOCATION: 'CREATE_UPDATE_PROCUREMENT_LOCATION',
  CREATE_UPDATE_PROCUREMENT_LOCATION_FAIL: 'CREATE_UPDATE_PROCUREMENT_LOCATION_FAIL',
  CREATE_UPDATE_PROCUREMENT_LOCATION_SUCCESS: 'CREATE_UPDATE_PROCUREMENT_LOCATION_SUCCESS',
  GET_PROCUREMENT_LOCATION_LIST: 'GET_PROCUREMENT_LOCATION_LIST',
  GET_PROCUREMENT_LOCATION_LIST_FAIL: 'GET_PROCUREMENT_LOCATION_LIST_FAIL',
  GET_PROCUREMENT_LOCATION_LIST_SUCCESS: 'GET_PROCUREMENT_LOCATION_LIST_SUCCESS',
  RESET_PROCUREMENT_LOCATION_LIST: 'RESET_PROCUREMENT_LOCATION_LIST',
  SET_ADD_NEW_LOCATION: 'SET_ADD_NEW_LOCATION',
  SET_PROCUREMENT_LOCATION_LIST_REQUEST: 'SET_PROCUREMENT_LOCATION_LIST_REQUEST',

  UPDATE_SELECTED_LOCATION: 'UPDATE_SELECTED_LOCATION',
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default ProcurementLocationType;
